<script>
	import Section from '$lib/Components/Layout/Section/Section.svelte';

	let { backgroundColor = 'white' } = $props();
</script>

<Section {backgroundColor}>
	<h2>Solutions</h2>
	<ul
		class="
    marker-circle grid w-full grid-flow-row place-content-around
    md:grid-flow-col
  "
	>
		<li class="flex items-center gap-x-4">
			<a href="/solutions/insulating-drafty-windows">Drafts & Savings</a>
		</li>
		<li class="flex items-center gap-x-4">
			<a href="/solutions/window-noise-reduction">Noise Reduction</a>
		</li>
		<li class="flex items-center gap-x-4">
			<a href="/solutions/block-damaging-uv-light">Light & UV</a>
		</li>
	</ul>
	<p>
		We offer custom solutions to a variety of window performance issues, from
		insulation and draft-blocking to noise penetration. Click the links above to
		discover how Indow window inserts solve each issue, and find the Indow grade
		that’s the best fit for your needs.
	</p>
</Section>
